import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { StockStatus } from 'src/components/stock-status';
import { usePriceRowContext } from '../../../price-row-context';
import type { StockStatusStates } from 'src/components/stock-status/types';
import type { ParamsAndReturnTypes } from 'src/components/translate';
import { StockStatusEnum } from './types';
import { StockStatusWrapper } from './styles';

interface IStockBadge {
  status?: StockStatusStates | null;
  featuredOffer?: boolean;
}

export const StockBadge: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IStockBadge>>
> = props => {
  const { t } = useAppContext();
  const { viewSize } = usePriceRowContext();

  const { status, featuredOffer } = props;

  const statusText =
    status === StockStatusEnum.PREORDER || status === StockStatusEnum.INCOMING
      ? t('product', 'stock-status.incoming')
      : t(
          'product',
          `stock-status.${
            status || 'unknown'
          }` as keyof ParamsAndReturnTypes['product']
        );

  return (
    <StockStatusWrapper $viewSize={viewSize}>
      <StockStatus
        status={status}
        tooltip={statusText as string}
        tooltipPlacement="top"
        featuredOffer={featuredOffer}
      />
    </StockStatusWrapper>
  );
};
